import React, { FC } from 'react';
import { SecondaryButton, PrimaryButton } from '../../../../components/button';
import styles from './feedback_box_button.module.scss';
import { FeedbackBoxButtonValues } from './FeedbackBox';

type Props = {
  response: FeedbackBoxButtonValues | null;
  value: FeedbackBoxButtonValues;
  onClick: (value: FeedbackBoxButtonValues) => void;
};

export const FeedbackBoxButton: FC<Props> = ({
  onClick,
  response,
  value,
  children,
}) => (
  <div className={styles.button}>
    {response === value ? (
      <PrimaryButton onClick={() => onClick(value)}>{children}</PrimaryButton>
    ) : (
      <SecondaryButton onClick={() => onClick(value)}>
        {children}
      </SecondaryButton>
    )}
  </div>
);
